import { render, staticRenderFns } from "./ListLead.vue?vue&type=template&id=5127cbc0&scoped=true&"
import script from "./ListLead.vue?vue&type=script&lang=js&"
export * from "./ListLead.vue?vue&type=script&lang=js&"
import style0 from "./ListLead.vue?vue&type=style&index=0&id=5127cbc0&scoped=true&lang=css&"
import style1 from "./ListLead.vue?vue&type=style&index=1&id=5127cbc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127cbc0",
  null
  
)

export default component.exports